<template>
  <section class="content-block small-padding">
    <transition name="slide-fade-delay-alt">
      <div
        v-if="active"
        class="block has-white-background"
      >
        <div class="inner-block is-flex">
          <h1 class="title">
            {{ $t("datenView.label.ticketReservation") }}
          </h1>

          <div style="width: 100%;">
            <div class="ticket select-extended is-flex">
              <div class="select-info">
                <h1 class="title">
                  {{ $t("datenView.label.totalAmount", {amount: $store.state.ticket_reservation_amount}) }}
                </h1>
                <p
                  class="subtitle no-margin"
                  v-if="$store.state.fahrttyp === 'ascent'"
                >
                  {{ $t("datenView.label.totalAmountHint") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'Anzahl',
  data() {
    return {
      active: false,
      totalSum: 0
    }
  },
  computed: {},
  mounted() {
    this.active = true

    this.$store.state.reservation = []

    if (this.$store.state.selectedType == 1) {
      this.sumUp_Bergfahrt_Fn()
      this.sumUp_Talfahrt_Fn()

    } else if (this.$store.state.selectedType == 2) {
      this.sumUp_Bergfahrt_Fn()
    } else if (this.$store.state.selectedType > 3) {
      this.sumUp_subset_Fn()
    } else {
      this.sumUp_Talfahrt_Fn()
    }
  },
  methods: {
    sumUp_Bergfahrt_Fn() {
      let bergfahrt_ResObj = {}
      bergfahrt_ResObj.slotId = this.$store.state.bergfahrt_Slot_ID
      bergfahrt_ResObj.slotReservation = []

      this.$store.state.reservation.push(bergfahrt_ResObj)

      let ticket_ResObj = {}
      ticket_ResObj.quantity = this.$store.state.ticket_reservation_amount

      bergfahrt_ResObj.slotReservation.push(ticket_ResObj)
    },
    sumUp_Talfahrt_Fn() {
      let talfahrt_ResObj = {}
      talfahrt_ResObj.slotId = this.$store.state.talfahrt_Slot_ID
      talfahrt_ResObj.slotReservation = []

      this.$store.state.reservation.push(talfahrt_ResObj)

      let ticket_ResObj = {}
      ticket_ResObj.quantity = this.$store.state.ticket_reservation_amount

      talfahrt_ResObj.slotReservation.push(ticket_ResObj)
    },
    sumUp_subset_Fn() {
      let subset_ResObj = {}
      subset_ResObj.slotId = this.$store.state.subset_Slot_ID
      subset_ResObj.slotReservation = []

      this.$store.state.reservation.push(subset_ResObj)

      let ticket_ResObj = {}
      ticket_ResObj.quantity = this.$store.state.ticket_reservation_amount

      subset_ResObj.slotReservation.push(ticket_ResObj)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-extended {
  width: 100%;
  display: block;
  position: relative;
  margin-top: 0.9rem;

  .select-info,
  .select-pricing {
    padding-top: 0.42rem;
    padding-left: 0.6rem;
  }

  .select-pricing {
    text-align: right;
    margin-left: auto;
    display: block;
    min-width: 65px;
  }

  .title {
    text-transform: none;
    margin-bottom: 0rem;
  }
}

.select-extended-sum {
  border-top: 1px solid rgb(200, 200, 200);
  padding-top: 1.2rem;
  margin-top: 0rem;

  .title {
    text-transform: none;
    margin-bottom: 0rem;
  }
}

.ticket {
  .select-info,
  .select-pricing {
    padding-top: 0rem;
    padding-left: 0rem;
  }
}

.no-margin {
  margin-bottom: 0 !important;
}

.align-right {
  text-align: right;
}
</style>
